import React from 'react';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

export const GoToRowLabel = () => {
	const { formatMessage } = useIntl();

	return <>{formatMessage(messages.goTo)}</>;
};
